import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyDU7Y0AEbymFQ2bC2H4CXcugCnPm4cLOeg",
    authDomain: "intermedio-1513801146022.firebaseapp.com",
    databaseURL: "https://intermedio-1513801146022.firebaseio.com",
    projectId: "intermedio-1513801146022",
    storageBucket: "intermedio-1513801146022.appspot.com",
    messagingSenderId: "534908779124"
};

const app = initializeApp(firebaseConfig);

export const firestore = getFirestore(app);
export const storage = getStorage(app);
export default app;